import React from 'react';
import { Box, MoveIcon, useTheme } from '@gr/ui-neo';
import { useLiveChatDraggHandlerStyles } from './useLiveChatDraggHandlerStyles';
export const LiveChatDraggHandler = (props) => {
    const theme = useTheme();
    const classes = useLiveChatDraggHandlerStyles({ theme });
    return (React.createElement("div", { role: "presentation", className: classes['livechat-dragg-handler'], onMouseDown: props.onStartDragging },
        React.createElement(Box, { className: classes['livechat-dragg-handler-icon'] },
            React.createElement(MoveIcon, null))));
};
